import { Component } from '@verndale/core';
import { tns } from 'tiny-slider/src/tiny-slider';
import { isFocusable } from '../../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      body: document.querySelector('body'),
      images: this.el.querySelector('.product-image-content__images'),
      button: this.el.querySelector('.product-image-content__modal-trigger'),
      modal: this.el.querySelector('.bu-modal'),
      modalContent: this.el.querySelector('.bu-modal__inner'),
      modalClose: this.el.querySelector('.bu-modal__close')
    };

    this.handleEscape = this.handleEscape.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleModalClickOutside = this.handleModalClickOutside.bind(this);
    this.isLink = [...this.el.classList].some(item => item === 'isLink');

    tns({
      container: this.dom.images,
      slideBy: 'page',
      controls: false,
      navPosition: 'bottom',
      mouseDrag: true,
      gutter: 20,
      responsive: {
        1440: {
          items: 2
        }
      }
    });
  }

  addListeners() {
    if (!this.isLink) {
      this.dom.button.addEventListener(
        'click',
        this.handleModalOpen.bind(this)
      );
      this.dom.modalClose.addEventListener(
        'click',
        this.handleModalClose.bind(this)
      );
    }
  }

  handleModalOpen() {
    this.dom.modal.classList.add('bu-modal--open');

    const scrollY = window.scrollY;
    this.dom.body.style.position = 'fixed';
    this.dom.body.style.top = `-${scrollY}px`;
    this.dom.body.classList.add('has-modal');
    this.dom.body.appendChild(this.dom.modal);
    this.focusFirstDescendant(this.dom.modal);
    document.addEventListener('keyup', this.handleEscape);
    document.addEventListener('focus', this.handleFocus, true);
    this.dom.modal.addEventListener('click', this.handleModalClickOutside);
  }

  handleModalClose() {
    this.dom.modal.classList.remove('bu-modal--open');

    const scrollY = document.body.style.top;
    this.dom.body.style.position = 'static';
    this.dom.body.style.top = '';
    this.dom.body.classList.remove('has-modal');
    this.dom.body.removeChild(this.dom.modal);
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    this.dom.button.focus();
    document.removeEventListener('keyup', this.handleEscape);
    document.removeEventListener('focus', this.handleFocus, true);
    this.dom.modal.removeEventListener('click', this.handleModalClickOutside);
  }

  handleEscape(e) {
    const key = e.which || e.keyCode;

    if (key === 27) {
      e.stopPropagation();

      this.handleModalClose();
    }
  }

  handleModalClickOutside(e) {
    if (
      e.target === this.dom.modalContent ||
      this.dom.modalContent.contains(e.target)
    ) {
      return;
    }

    this.handleModalClose();
  }

  handleFocus(e) {
    if (this.ignoreUtilFocusChanges) return;

    if (this.dom.modal.contains(e.target)) {
      this.lastFocus = e.target;
    } else {
      this.focusFirstDescendant(this.dom.modal);

      if (this.lastFocus === document.activeElement) {
        this.focusLastDescendant(this.dom.modal);
      }
      this.lastFocus = document.activeElement;
    }
  }

  focusFirstDescendant(element) {
    for (let i = 0; i < element.childNodes.length; i++) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusFirstDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  focusLastDescendant(element) {
    for (let i = element.childNodes.length - 1; i >= 0; i--) {
      const child = element.childNodes[i];
      if (this.attemptFocus(child) || this.focusLastDescendant(child)) {
        return true;
      }
    }
    return false;
  }

  attemptFocus(element) {
    if (!isFocusable(element)) {
      return false;
    }

    this.ignoreUtilFocusChanges = true;
    try {
      element.focus();
    } catch (e) {
      return;
    }
    this.ignoreUtilFocusChanges = false;
    return document.activeElement === element;
  }
}

export default Module;
